// extracted by mini-css-extract-plugin
module.exports = {"errorWrapper":"ErrorBoundary_errorWrapper__1arNa"};